export default __webpack_public_path__ + "static/media/1.06862b5e.svg";